export default class UrlHelper {
    static url(path) {
        return `${CBS.Registry.region.prefix}${path}`;
    }

    static getHomePageURL() {
        if (window.location.host.indexOf('paramountplus.com') === -1) {
            return UrlHelper.url('/');
        }

        return UrlHelper.url('/home');
    }

    /**
     * opens in new tab if different domain url
     * @param url
     */
    static goTo(url) {
        const a = document.createElement('a');
        a.href = url;

        if (a.hostname !== window.location.hostname) {
            window.open(url, '_blank', 'noopener');
        } else {
            window.location = a.href;
        }
    }

    /**
     * Appends user bundleStatus query param if not anon. Used for carousel caching
     * @param url
     */
    static appendBundleStatusAndPackageCode(url) {
        if (CBS.Registry.user.bundleStatus !== undefined) {
            let sep = url.match(/\?.+=.+/) == null ? '?' : '&';
            url += sep + 'bundleStatus=' + CBS.Registry.user.bundleStatus;
        }

        if (CBS.Registry.user.packageCode !== undefined) {
            let sep = url.includes('?') === true ? '&' : '?';
            url += sep + 'packageCode=' + CBS.Registry.user.packageCode;
        }
        return url;
    }
}
